import React from "react";
// import flexible from '../../utils/flexible';
import "./index.less";

class ServiceAgreenment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    // document.title = '服务协议';
    return (
      <div className="page_type_h5_select">
        <article id="ServiceAgreenment">
          <h2 style={{ textAlign: "center" }}>远程慧联用户协议</h2>
          <section className="dataTime">
            <p>本版本发布日期：2025年3月6日</p>
            <p>本版本生效日期：2025年3月6日</p>
          </section>
          {/*  提示条款 */}
          <section>
            <h3>提示条款</h3>
            <p>
              欢迎您使用远程慧联提供的产品和服务（下称"服务"），本协议自发布之日起即刻生效。本协议各条款前"【】"所列索引关键词仅为帮助您理解该条款表达的主旨之用，不影响或限制本协议条款的含义或解释。
              为维护您自身权益，建议您仔细阅读各条款具体表述。【审慎阅读】
              您在申请注册流程中点击同意本协议之前，应当认真阅读本协议。
              <b>
                请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款、法律适用和争议解决条款。免除或者限制责任的条款将以粗体下划线标识，您应重点阅读。
              </b>
              如您对协议有任何疑问，可向远程慧联客服致电咨询。 【签约动作】
              当您按照注册页面提示填写信息、阅读并同意本协议且完成全部注册程序后，即表示您已充分阅读、理解并接受本协议的全部内容，并与远程慧联达成一致，成为远程慧联"用户"。
              <b>
                阅读本协议的过程中，如果您不同意本协议或其中任何条款约定，您应立即停止注册程序
              </b>
              。
            </p>
          </section>
          {/*  一、协议范围 */}
          <section>
            <h3>一、协议范围</h3>
            <p>
              <b>
                1.1
                本《远程慧联平台用户协议》（下称"本协议"）是您（以下简称"您/用户"）和浙江吉利远程新能源商用车集团有限公司、浙江绿色慧联有限公司和/或其关联公司（以下简称"公司/我们/远程慧联"）就您使用远程慧联官方网站/APP/小程序/H5页面等远程慧联提供的网络平台（以下合称"远程慧联平台"）以及相关服务所订立的协议。其中远程慧联APP、小程序（包括绿色慧联小程序、远程慧充电小程序）由浙江吉利远程新能源商用车集团有限公司和浙江绿色慧联有限公司共同运营，浙江绿色慧联有限公司负责远程慧联APP、小程序的整体运营，浙江吉利远程新能源商用车集团有限公司负责远程慧联APP及小程序中购车功能的运营。
              </b>
            </p>
            <p>
              <b>
                1.2
                本协议构成您使用远程慧联平台及相关服务的先决条件，请您在使用任何远程慧联网络平台及相关服务前仔细阅读本协议的各项条款。
                我们善意地提醒您，本协议中与您权益（可能）存在重大关系的条款，特别是免除或者限制我们责任的条款、限制您权利的条款、争议解决和法律适用条款等，我们已采用加粗和/或加下划线{" "}
              </b>
              的方式进行特别提示，请您留意并重点阅读。
            </p>
            <p>
              1.3
              请您理解，远程慧联网络平台及相关服务经更新后仅面向18周岁以上的成年人提供服务，如果您的年龄小于18周岁，请您在监护人的知情并且同意下注册和使用远程慧联网络平台及相关服务。
            </p>
            <p>
              1.4
              本协议为我们向您提供远程慧联网络平台及相关服务的通用性服务协议。在远程慧联网络平台及相关服务的页面中，可能包含针对某些服务/功能的特定规则，包括产品在开发过程中不时更新与发展而需要向您单独展示的规则、流程等。任何单独展示的具体规则均与本协议具有同等效力。具体规则与本协议有冲突的，以具体规则为准。具体规则未提及的事项，以本协议为准。
            </p>
            <p>
              1.5
              当您按照注册页面提示填写信息、阅读并同意本协议，即表示您已充分阅读、理解并接受本协议的全部内容。阅读本协议的过程中，如果您不同意本协议或其中任何条款约定，您应立即停止注册程序和/或使用远程慧联网络平台或相关服务。
            </p>
            <p>
              1.6
              随着我们产品和服务的变化与更新，以及相关法律法规及政策的变化，我们会根据需要不定期修改本协议或附件。我们会将相关的修改内容提前发布在网络平台中并弹窗要求您确认。本协议或附件修改后，如您继续使用公司提供的网络平台及相关服务，即视为您已阅读、理解并接受相关修订内容。如您不接受相关修订或更新的内容，请立即停止使用公司提供的网络平台或相关服务。
            </p>
            <p>
              1.7
              如您在阅读本协议过程中有任何疑惑或需要咨询其他相关事宜，您可通过本协议所载明的联系方式联系我们，我们会尽快给您做出解答。
            </p>
          </section>
          {/*  二、账号注册及管理 */}
          <section>
            <h3>二、账号注册及管理</h3>
            <h4>2.1 账号注册</h4>
            <p>
              2.1.1
              您理解并同意，为充分使用远程慧联网络平台及相关服务，如您是18周岁以上的成年人，您可以自行注册远程慧联网络平台的账号。该账号是您已注册用户身份，使用远程慧联网络平台及相关服务的凭证。
            </p>
            <p>
              2.1.2
              您理解并同意，您可以选择合法的手机号码创建账号，并设置安全密码进行注册。您也可以使用第三方账号进行登录并使用远程慧联网络平台及相关服务，我们将基于您使用的第三方账号为您创建账号。
            </p>
            <p>
              2.1.3
              <b>
                您理解并同意，为快速准确提供服务，提升用户体验，保障用户安全，远程慧联网络平台在提供某些功能和/或服务，如签署电子合同、线上提交租车订单、绑定车辆等等，会要求您提供额外的信息，包括提供身份实名认证信息，详情请参阅《远程慧联隐私政策》。您理解并同意，如您不完成实名认证和/或资质认证，您将有可能无法正常访问/登录绿色慧联产品或使用服务。
              </b>
            </p>
            <p>
              <b>
                2.1.4
                您有义务在注册时提供您的真实资料，并保证诸如电子邮件地址、联系电话、联系地址、邮政编码等内容的有效性及安全性。如果因您的个人信息不真实而引起的问题及其产生的后果有您及您的责任人承担，绿色慧联不负任何责任。
              </b>
            </p>

            <h4>2.2 账号管理</h4>
            <p>
              2.2.1
              为了向您提供更加个性化与优质的服务，建议您补充完善个人资料。如果上述信息发生变化，您应及时更新。您不得使用虚假信息、冒用他人身份或使用他人手机号码等进行注册。若您违反上述保证，我们有权终止为您提供所有远程慧联网络平台或相关服务，并有权对您的账号采取包括但不限于警告、限制或禁止使用远程慧联网络平台的部分或全部功能、封禁账号及删除账号相关信息等处理措施。由于您未提供真实或未及时更新信息导致的任何损失，由您自行承担责任，我们对此不承担任何责任。
            </p>
            <p>
              2.2.2
              您理解并同意，您使用某一手机号进行注册时，仅能注册一个账号。您在申请注册及后续使用远程慧联网络平台时，您提交的账号昵称、评论发言等不能出现违法、违反社会公德或侵犯他人权益的内容。我们有权对您提交注册信息的合法性进行审查，若确实存在前述情形，我们有权不予注册。已经注册账号的，或您提交的注册信息存在上述违法和不良信息的，我们有权不经通知单方采取警告、限期改正、临时封禁、永久封禁账号等措施，您应当自行承担由此导致的全部责任。
            </p>
            <p>
              2.2.3
              您理解并同意，您不会通过任何手段恶意注册远程慧联网络平台账号（包括但不限于使用无效手机号、使用他人手机号码等恶意注册）或利用远程慧联网络平台账号进行违法活动、捣乱、骚扰、欺骗其他用户以及其他违反法律或本协议的行为，我们有权对存在上述行为的账号不经通知单方采取警告、限期改正、临时封禁、永久封禁账号等措施，您应当自行承担由此导致的全部责任。我们有权通过技术手段（包括收集设备信息）判断并排除恶意注册的情况，以维护远程慧联及其他远程慧联用户的合法权益。同时，我们有权将上述行为移交司法部门处理。
            </p>
            <p>
              2.2.4
              <b>
                <u>
                  您理解并同意，远程慧联网络平台账号的所有权归远程慧联所有，您仅拥有远程慧联网络平台账号的有限使用权
                </u>
              </b>
              。您应对您账号下发生的一切活动承担全部法律责任，无论该活动是由您本人进行的，还是由您授权的第三方实行的。您应妥善保管远程慧联网络平台账号，不应将远程慧联网络平台账号赠与、转让、出借、出租、售卖、与他人共享使用，不应将远程慧联网络平台账号及密码相关的任何信息告知第三人或进行有价交易行为等。因您未采取保密措施、保密措施不当或您的其他行为致使账号信息等丢失或泄露所引起的一切损失和后果，均由您自行承担。我们有权根据实际情况，不经通知单方面采取警告、限期改正、临时封禁、永久封禁账号等措施，您应自行承担由此造成的全部责任。
            </p>
            <p>
              2.2.5
              <b>
                如果您使用远程慧联网络平台及相关服务，即表示您愿意接受我们发出的有关本服务的相关邮件、短信及/或远程慧联网络平台的系统消息
              </b>
              。这类信息对您正常使用远程慧联网络平台及相关服务，接收重要提醒和通知非常重要。对因此有可能给您造成的困扰，我们不承担任何责任。如果相关法律要求我们需要取得您的授权后再向您发送的（如一些营销信息），我们会在取得您的相应授权后再向您发送。
            </p>

            <h4>2.3 账号保管</h4>
            <p>
              2.3.1
              您须对注册账号进行妥善保管，并应正确和安全地使用账号信息（包括但不限于账号及密码）。如果您发现您的账号和/或密码可能丢失或泄露、被他人非法使用或有使用异常情况，您可以通过本协议载明的联系方式联系我们，否则该账号下所有使用行为将视为您本人的行为，因账号丢失或被他人非法使用所造成的损失也由您自行承担。您在通知我们的同时应当提供您真实有效的证明材料，以证明您的注册用户身份。若您不能提供有效的材料，我们可能不能为您提供相应的账号安全服务，相应的风险由您自己承担。
            </p>
            <p>
              2.3.2
              为了保障您的账号安全，我们可能会定期或不定期地采用不同的方式对您的账号进行验证，包括但不限于要求输入验证码，短消息验证等。如您无法完成验证或拒绝验证的，我们可合理地怀疑您的账号出现异常或被盗，并可能会暂停向您提供服务或采取进一步措施。如果您认为您有相关证据证明您的账号不存在异常情况，请您及时通过本协议所载明的联系方式联系我们，您在联系我们的同时应当提供您真实有效的身份证明材料，以证明您的注册用户身份。我们会及时评估并进行处理，以免影响您的正常使用。
            </p>

            <h4>2.4 账号注销</h4>
            <p>
              2.4.1
              您有权注销您的账号，您可以通过访问远程慧联APP、小程序页面上的"我的"-"设置"-"账户与安全"-"账号注销"申请注销账号，或本协议载明的联系方式联系我们协助您注销，提交申请后，我们将在15个工作日内审核，确认您的账户处于安全状态、账号下无任何关联车辆、账号财产结清、无进行中的订单等问题后，我们将为您注销账户。您注销账户后，我们将停止为您提供产品/服务，并依据您的要求，除法律法规另有规定外，我们将删除您的个人信息或做匿名化处理。我们可能根据相关网络平台或相关服务的特点设置一定的注销条件，您需要在满足该等条件后才可以注销您的账号。尽管我们会依照法律规定留存部分信息，但您注销账号后可能会导致您账号下的所有数据永久丢失，您需承担该风险。本协议终止后，除法律有明确规定外，远程慧联无义务向您或您指定的第三方披露您账号中的任何信息。
            </p>
            <p>
              2.4.2 请您理解并同意，
              <u>
                若您主动注销账号，则您在远程慧联网络平台的积分/卡券（如有）都将视为自动放弃，除法律法规明确规定的情形外，我们不予退还相应的现金价值或任何其他形式的补偿。
              </u>
            </p>
            <p>
              从申请注销远程慧联网络平台账号到最后注销成功这一期间，如果您的远程慧联网络平台账号涉及争议或纠纷，包括但不限于投诉、举报、诉讼、仲裁、国家机关调查等，我们有权自行中止或终止您的远程慧联网络平台注销流程，而无需另行获得您的同意。
            </p>

            <p>
              2.4.3
              我们提示您注意，您注销远程慧联网络平台账号并不代表因您使用该账号所导致的相关责任会通过注销账号而豁免或减轻。
            </p>
          </section>
          {/*  三、用户行为规范 */}
          <section>
            <h3>三、用户行为规范</h3>
            <h4>3.1 用户权利</h4>
            <p>
              3.1.1
              您只能在本协议以及我们明示授权的范围内使用远程慧联网络平台及相关服务。
            </p>
            <p>
              3.1.2
              根据本协议，您在使用远程慧联网络平台及相关服务期间，您有权随时向我们提出有关的意见和建议，以帮助我们更好地向您提供服务。
            </p>
            <p>
              3.1.3
              根据本协议条款和规则，您可以在远程慧联网络平台内上传原创或取得了合法授权（含转授权的）图片、文字、音视频等内容。我们保留自行或委托有资质的第三方对您上传的内容进行审查的权利。如您上传的内容涉嫌具有违反法律法规或本协议约定的情形的，我们可不经通知单方采取拒绝您上传、直接屏蔽、删除相关信息、对您相关账号进行封禁等措施。被永久封禁的手机号将不能再次注册。您应自行承担以上行为导致的一切不利后果，我们不承担您自身违反法律法规行为而造成的损失。如因您的行为给我们造成不利后果的您应负责消除影响，并且赔偿我们因此遭受的一切损失，包括但不限于财产损害赔偿、名誉损害赔偿、律师费、交通费等因维权而产生的合理费用。
            </p>
            <p>
              3.1.4
              请您理解并知悉，如您上传的内容超过合理储存期限或存在违法违规等情况，我们有权对您上传的内容进行删除或匿名化处理，如因此给您的行为造成了影响，我们不承担任何的法律责任。我们善意地提示，如您上传的信息对您特别重要，请您及时自行备份相关内容，以免造成您不必要的损失。
            </p>

            <p>
              <b>3.2 用户义务</b>
            </p>
            <p>
              3.2.1
              在直接注册账号时，您确认您已具备与您即将使用的服务相对应的民事行为能力或合法有效授权来签署或履行本协议。若您不具备前述与您行为相适应的民事行为能力，则您及您的监护人应依照法律规定承担因此而导致的相应法律后果。
            </p>
            <p>
              3.2.2
              您注册时应当提供真实、准确、完整的信息，以便我们为您提供对应的用户服务。您应当仅从我们授权的官方渠道获取和使用我们的网络平台及相关服务，如果您通过非官方渠道下载或者使用我们服务的，您应对您在使用该等非授权服务过程中产生的损失负责。
            </p>
            <p>
              3.2.3
              您理解并同意，除了部分服务可通过离线模式进行使用，在使用远程慧联网络平台及相关服务接入互联网时，您需自行承担因您使用远程慧联网络平台及相关服务所产生的上行和下行的网络通信及流量费用，上述费用将由网络运营商向您直接收取。您可以通过相应的设备设置页面对网络使用信息进行相关设置。
            </p>
            <p>
              3.2.4
              在您完成注册手续后，意味着您已获得该账号的使用权。您可随时登录我们的网络平台查询并管理该账号下您的个人信息。您应妥善保管您的账号和密码（包括但不限于您授权登录的第三方账号、密码、动态密码、验证码等）。除非您事先通知我们您的账号或密码被泄露，否则任何通过您的账号和密码操作或实施的行为都将视为您本人的行为，由您本人承担相应的责任和后果。
            </p>
            <p>
              3.2.5
              您理解并同意遵守本协议条款和规则，并及时查看、遵守远程慧联网络平台中不时公布与/或更新的各项条款和规则。
            </p>
            <p>
              3.2.6
              您理解并同意，随着远程慧联网络平台及相关服务的发展，部分产品与/或服务可能属于付费服务，您需要按照相关条款或者协议支付相应的费用，具体协议或者条款请查看远程慧联网络平台为您展示的相关规定。
            </p>
            <p>
              3.2.7
              如您发现任何未经授权使用您账号或其他可能导致您账号遭窃、遗失的情况，请您立即以书面、有效的方式通知我们。我们将在采取必要的措施核实您的身份后尝试进行处理。在此，您理解我们对您的任何请求采取行动均需要合理时间，且我们应您请求而采取的行动很可能无法避免或阻止侵害后果的形成或扩大。除公司存在过错外，我们对因上述情况产生的后果（包括但不限于您的任何损失）不承担任何责任。
            </p>
            <p>
              3.2.8
              您在使用远程慧联网络平台及相关服务时，必须遵守中华人民共和国相关法律法规的规定，不得使用我们提供的服务进行任何违法或不正当的活动。
            </p>
            <p>
              3.2.9
              如您在使用本协议项下各服务过程中，有违反法律法规、本协议或是各项服务协议规定的，我们保留收回、限制、冻结或强制修改您所使用的账号、昵称、头像等个人信息的权利。由此给您带来的损失，由您自行承担。
            </p>
            <p>
              3.2.10
              请您注意，您通过自身账号在我们提供的各项服务中所发布、提供的任何信息、内容都应合法合规，需要取得授权的，已经事先获得相应的许可。如我们收到与您提供内容的相关投诉或举报，我们在必要情况下将采取法律所允许的方式，向争议的相对方、有关部门或监管部门提供包括您账号在内的必要的信息，以便解决争议。
            </p>
            <p>
              我们授权您非商业性使用远程慧联网络平台及相关服务。这意味着您可以自主选择下载、安装、使用及停止使用或卸载远程慧联网络平台。但是如果要进行商业性使用（包括但不限于：销售、复制、散发、预装、捆绑或用于其他商业活动）时，必须事先获得我们的书面授权许可。
            </p>
          </section>
          {/*  四、服务范围 */}
          <section>
            <h3>四、服务范围</h3>
            <p>
              4.1
              本APP内容由远程慧联提供。为了让您使用方便，本APP可能会包含由第三方提供的服务内容，我们会在相关活动页面对第三方提供的服务内容进行详尽说明和提示。同时，我们提供连接到关联公司和其他企业网站的链接。我们会尽量进行审核和筛查。请您谨慎判断是否接受这些服务。对因您使用第三方服务所遭受的任何损失或损害，您有权要求第三方服务提供方承担责任。应您要求，我们将依法承担配合调查、协助取证责任。必要时，我们将删除第三方链接。在您使用本APP的过程中，某些特定服务可能会有单独的协议、规则或指引，这些文件均为本协议不可分割的组成部分，您在使用这些服务时需了解、接受并遵守相关的协议、规则或指引。
            </p>
            <p>
              4.2
              我们在获取您的授权后，向您提供包括但不限于如下服务（不同网络平台提供的服务可能存在差异，请以实际为准）：租车、购车、充电、查找电站、维保预约、安全培训、ETC服务、年审预约、账单管理、合同管理、车辆授权、车辆监控等。除非本协议另有其它明示规定，我们增加、强化或修改目前服务的任何功能，包括所推出的新产品或服务，均受本协议之规范。
            </p>
            <p>
              4.3
              请您注意，您在使用远程慧联网络平台某一特定服务或功能时，该服务或功能可能会另有单独的协议、相关业务规则等（以下统称为"单独协议"），您在使用该项服务前请阅读并同意相关的单独协议，您使用前述特定服务，即视为您同意相关单独协议。若本协议的条款与单独协议存在任何冲突，以单独协议的约定为准。
            </p>
            <p>
              <b>
                4.4
                您理解并同意，远程慧联公布信息不意味着对服务承诺，具体服务内容以您实际签署的相关协议为准。除本协议或补充协议中明确规定的内容外，远程慧联、远程慧联不同地区子公司和/或关联法律实体及其供应商对服务均不作任何具体承诺。
              </b>
            </p>
            <p>
              <b>
                4.5
                远程慧联依照法律规定履行基础保障义务，但对于下述原因导致的协议履行障碍、履行瑕疵、履行延后或展行内容变更等情形，远程慧联并不承担相应的违约责任：
              </b>
            </p>
            <p>
              <b>
                (1)
                因自然灾害、罢工、暴乱、战争、政府行为、司法行政命令等不可抗力因素；
              </b>
            </p>
            <p>
              <b>
                (2) 因电力供应故障、通讯网络故障等公共服务因素或第三人因素；
              </b>
            </p>
            <p>
              <b>
                (3)
                在远程慧联已尽善意管理的情况下，因常规或紧急的设备与系统维护、设备与系统故障、网络信息与数据安全等因素。
              </b>
            </p>
          </section>
          {/*  五、知识产权 */}
          <section>
            <h3>五、知识产权</h3>
            <p>
              5.1
              除明显归属于合作伙伴、第三方所有的信息资料外，与远程慧联有关的一切著作权、商标权、专利权、商业秘密等知识产权，以及与服务相关的所有信息内容，包括但不限于：程序、软件、动画、文本、图片、图形、音频、视频资料等单独或组合的知识产权均归远程慧联所有，均受中华人民共和国著作权法、商标法、专利法、反不正当竞争法和相应的国际条约以及其他知识产权法律法规的保护。
            </p>
            <p>
              5.2
              未经公司书面同意，上述资料均不得在任何媒体直接或间接发布、传播、出于传播或发布目的而复制或再发行，或者被用于其他任何商业目的。若用户违反上述约定，我们将依法追究法律责任。
            </p>
            <p>
              5.3
              <b>
                请您注意，您通过远程慧联网络平台上传、创作或发布的内容，包括声音素材、视频、动画、图片、文章或上述材料的任意组合等，应该是您的原创，或者您在发布前已经取得了对应权利人的授权
              </b>
              。如上述内容存在权利瑕疵，进而发生侵权事项，您将承担全部责任，远程慧联可对您发布的信息依法或依本协议进行删除或屏蔽；您还需对由此造成远程慧联及关联公司或第三方公司的损失进行赔偿。同时，您同意授权我们及关联公司以自己的名义或委托专业机构对上述的内容（含衍生作品）的侵权行为采取包括监测侵权、发送律师函/公司函、根据实际情况与管辖提起诉讼或仲裁、调解、和解在内的措施，并发起独立的维权，单独获得全部赔偿或补偿。
            </p>
            <p>
              5.4
              我们尊重他人知识产权和合法权益，呼吁您也要同样尊重知识产权和他人合法权益。若您认为您的知识产权或其他合法权益被侵犯，请及时联系我们并提供相关权属证明。
            </p>
            <p>
              5.5
              您理解并同意，在同意本协议后，上述内容中并非专属您个人且法律法规允许转让的权利，如著作权中的财产权部分（包括但不限于：复制权、发行权、出租权、展览权、表演权、放映权、广播权、信息网络传播权、摄制权、改编权、翻译权、汇编权以及应当由著作权人享有的其他可转让权利），您同意授权给我们及我们的关联公司，您可与我们或我们的关联公司另行签署相关协议，具体以相关协议约定为准。我们及我们的关联公司在此基础上，可以在不违反现行法律规定及尊重知识产权的前提下，将上述内容用于商业或非商业用途，包括修改、复制、改编、翻译、汇编或制作，进而形成知识产权归属远程慧联或我们关联公司的衍生产品，这些衍生产品可以被用于网站、电子杂志、杂志、刊物、海报、公众号文章、远程慧联网络平台或其他媒介渠道；在必要的情况下，我们还会根据实际情况，向第三方自主进行再次转授权。
            </p>
            <p>
              5.6
              【侵权处理】远程慧联非常尊重知识产权。如果您认为远程慧联向您展示的和/或远程慧联向您提供服务内中的任何信息、内容、资料可能涉嫌侵犯相关合法权益，可以与远程慧联联系（客服电话为400-826-2266/0571-82899926），远程慧联收到后将及时处理。
            </p>
          </section>
          {/*  六、用户个人信息保护 */}
          <section>
            <h3>六、用户个人信息保护</h3>
            <p>
              我们非常重视对您的个人信息保护。为了向您提供相关服务或功能，我们针对不同的业务功能、业务场景，将对您或您的车辆有关的个人信息进行合理必要的收集和使用。我们将基于不同的合法基础处理您的个人信息。若我们基于"同意"的合法基础处理您的个人信息，我们将在获得用您的同意后处理您的个人信息。关于我们收集、使用、存储、保护您的个人信息的目的、方式和范围，您可以参阅《远程慧联隐私政策》。
            </p>
          </section>
          {/*  七、违约赔偿 */}
          <section>
            <h3>七、违约赔偿</h3>
            <p>
              <b>
                7.1
                如由于您违反本协议或任何法律、法规或侵害第三方的权利，而引起第三方对远程慧联相关产品提出的任何形式的索赔、要求、诉讼，远程慧联有权向您追偿相关损失，包括但不限于本app及远程慧联的名誉损失、因此支出的法律费用、及向第三方支付的补偿金等。
              </b>
            </p>
            <p>
              <b>
                7.2
                如因远程慧联违反有关法律、法规或本协议项下的任何条款而给您造成的损失，远程慧联同意承担由此造成的损害赔偿责任。
              </b>
            </p>
            <p>
              <b>
                7.3
                如由于您因远程慧联产品上的交易与其他用户产生诉讼，其他用户有权通过司法部门要求远程慧联提供相关资料。经国家生效法律文书或行政处罚决定确认您存在违法行为，或者远程慧联有足够事实依据可以认定您存在违法或违反本服务协议的行为的，远程慧联有权在本产品及网站上公布您的违法、违约行为，并将该内容记入任何与您相关的信用资料和档案。
              </b>
            </p>
          </section>
          {/*  八、协议变更、终止及其他 */}
          <section>
            <h3>八、协议变更、终止及其他</h3>
            <p>
              <b>
                8.1
                您同意，远程慧联基于平台服务的安全性，有权中止向您提供部分或全部远程慧联平台服务，暂时冻结您的账户，待安全问题解决后及时恢复，并对中止、冻结及恢复的事实及时通知。如果网站的安全问题是由于您的违法行为引起，远程慧联有终止向您提供部分或全部远程慧联平台服务，永久冻结（注销）您的帐户，并有权向您对损失进行索赔。
              </b>
            </p>
            <p>
              <b>
                8.2
                您有权在结清全部应付费用后向远程慧联要求注销您的账户，您可随时通过永久性删除移动设备上安装的应用程序，届时，您与远程慧联基于本协议的合同关系即终止。您的账户被注销后，远程慧联将删除您的个人信息或做匿名化处理。远程慧联没有义务为您保留或向您披露您账户中的任何信息，也没有义务向您或第三方转发任何您未曾阅读或发送过的信息。
              </b>
            </p>
            <p>
              <b>
                8.3
                您同意，您与远程慧联的协议关系终止后，远程慧联仍享有下列权利：
              </b>
            </p>
            <p>
              <b>
                (1)
                继续保存您未及时删除的注册信息及您使用远程慧联平台服务期间发布的所有信息至法律规定的记录保存期满。
              </b>
            </p>
            <p>
              <b>
                (2)
                您在使用远程慧联平台服务期间存在违法行为或违反本协议和/或规则的行为的，远程慧联仍可依据本协议向您主张权利。
              </b>
            </p>
            <p>
              <b>
                8.4
                您同意，远程慧联保留随时修改或替换本协议，或者更改、暂停服务及应用程序（包括不限于任何功能、数据库或内容）的权利。届时，我们将通过第九条通知送达条款约定的途径通知您。
              </b>
            </p>
            <p>
              <b>
                8.5
                如果您不同意远程慧联对本协议相关条款所做的修改，您有权利停止使用远程慧联服务。如果您继续使用远程慧联服务，则视为您接受我们对协议相关条款所做的修改，并同意按照修改后的内容履行协议。
              </b>
            </p>
          </section>
          {/*  九、通知条款 */}
          <section>
            <h3>九、通知条款</h3>
            <p>
              9.1
              【有效联系方式】远程慧联将通过您提供的有效联系方式的其中之一或其中若干向您送达各类通知，而此类通知的内容可能对您的权利义务产生重大的有利或不利影响，请您务必及时关注。您提供的有效联系方式包括：您准确完整地提供您的真实有效的联系方式（包括您的电子邮件地址、联系电话、联系地址等），以便远程慧联或其他用户与您联系。
              <b>
                您了解并同意，您有义务保持您提供联系方式的真实性及有效性。联系方式发生变更的，您有义务及时更新有关信息，并保持可被联系的状态。
              </b>
            </p>
            <p>
              9.2
              【通知送达】远程慧联通过本协议第9.1约定的有效联系方式向您发出通知。
              <b>
                其中，以电子的方式发出的书面通知，包括但不限于在远程慧联公告，向您提供的联系电话发送手机短信，向您提供的电子邮件地址发送电子邮件，在发送成功后即视为送达；以纸质载体发出的书面通知，按照提供联系地址交邮后的第五个自然日即视为送达。
              </b>
            </p>
            <p>
              9.3
              对于在远程慧联上因交易活动引起的任何纠纷，您同意司法机关（包括但不限于人民法院）可以通过手机短信、电子邮件等现代通讯方式或邮寄方式向您送达法律文书（包括但不限于诉讼文书）。您指定接收法律文书的手机号码、电子邮箱等联系方式为您在远程慧联注册、更新时提供的手机号码、电子邮箱联系方式，司法机关向上述联系方式发出法律文书即视为送达。
            </p>
            <p>
              9.4
              你应当保证所提供的联系方式是准确、有效的，并进行实时更新。如果因提供的联系方式不确切，或不及时告知变更后的联系方式，使法律文书无法送达或未及时送达，由您自行承担由此可能产生的法律后果。
            </p>
          </section>
          {/*  十、适用法律和管辖 */}
          <section>
            <h3>十、适用法律和管辖</h3>
            <p>
              10.1 【法律适用】
              <b>
                本协议之订立、生效、解释、修订、补充、终止、执行与争议解决均适用中华人民共和国法律；如果法律无相关规定的，参照商业惯例和/或行业惯例。
              </b>
            </p>
            <p>
              10.2 【管辖条款】
              <b>
                您因使用远程慧联服务所产生和/或与服务有关的争议，由远程慧联与您协商解决；协商不成时，任何一方均可向被告所在地人民法院提起诉讼。
              </b>
            </p>
          </section>
          {/*  十一、附加条款 */}
          <section>
            <h3>十一、附加条款</h3>
            <p>
              11.1
              在远程慧联相关产品的某些部分或页面中可能存在除本协议以外的单独的附加服务条款，当这些条款存在冲突时，页面中的附加条款优先适用。
            </p>
            <p>
              11.2
              本协议任一条款被视为废止、无效或不可执行，该条应视为可分的且并不影响本协议其余条款的有效性及可执行性。
            </p>
            <p>
              如果您有任何关于本协议的问题，欢迎随时联系我们，客服热线：400-826-2266。
            </p>
          </section>
        </article>
      </div>
    );
  }
}

export default ServiceAgreenment;



// WEBPACK FOOTER //
// ./src/staticPage/serviceAgreenment/index.js